import React from 'react';

import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";

/*
Simple info popup
 */
const InfoPopup = ({
	title,
	message,
	onHide,
	footer = (
		<Button
			onClick = {onHide}>
			{'OK'}
		</Button>
	),
}) => (
	<Modal
		show = {true}
		onHide = {onHide}>
		{title &&
			<Modal.Header>
				<Modal.Title>
					{title}
				</Modal.Title>
			</Modal.Header>}
		{message &&
			<Modal.Body>
				{message}
			</Modal.Body>}
		<Modal.Footer>
			{footer}
		</Modal.Footer>
	</Modal>
);

export default InfoPopup;
